<template>
  <div class="personal">
    <div class="banner-box">
      <div class="con-box">
        <h5 class="usernames">张民国</h5>
        <p class="company">省文旅厅指挥中心</p>
      </div>
    </div>
    <div class="personal-list-box">
      <div class="items-box">
        <img src="../../assets/index/ic_mine.png" alt="" class="left-icon" />
        <div class="items-text">个人信息</div>
        <img src="../../assets/index/ic_bm_jt.png" alt="" class="right-icon">
      </div>
      <div class="items-box" @click="$router.push({path: '/permissionsInfo'})">
        <img src="../../assets/index/ic_quanxian.png" alt="" class="left-icon" />
        <div class="items-text">我的权限</div>
        <img src="../../assets/index/ic_bm_jt.png" alt="" class="right-icon">
      </div>
      <div class="items-box">
        <img src="../../assets/index/ic_shezhi.png" alt="" class="left-icon" />
        <div class="items-text">设置</div>
        <img src="../../assets/index/ic_bm_jt.png" alt="" class="right-icon">
      </div>
    </div>
    <div class="btn-fuc">切换账号</div>
    <div class="btn-fuc">退出登录</div>
  </div>
</template>

<script>

    export default {
        components: {

        },
        data () {
            return {}
        },
        computed: {

        },
        watch: {

        },
        methods: {

        },
        mounted () {
        },

        created () {
        }

    }
</script>

<style scoped lang="less">
.personal{
  width:100%;
  height:100%;
  background:rgba(251,251,251,1);
  .banner-box{
    width: 100%;
    height: 112px;
    background: #3EB479;
    position: relative;
    margin-bottom: 43px;

    .con-box{
      width:351px;
      height:102px;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      position: absolute;
      bottom: -25px;
      left: 0;
      right: 0;
      margin: auto;
      box-sizing: border-box;
      padding: 24px 16px;

      .usernames{
        font-size:20px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:20px;
        margin-bottom: 15px;
      }

      .company{
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:18px;
      }

    }
  }
  .personal-list-box{
    width:351px;
    height:196px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    margin: 0 auto;

    .items-box{
      height: 64px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 16px 0 14px;
      border-bottom: 1px solid #EEEEEE;

      &:last-child{
        border-bottom: none;
      }

      .left-icon{
        width: 20px;
        height: 20px;
        margin-right: 11px;
      }
      .items-text{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:14px;
        flex: 1;
      }
      .right-icon{
        width: 9px;
        height: 14px;
      }
    }
  }
  .btn-fuc{
    width:351px;
    height:46px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
    border-radius:3px;
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:46px;
    text-align: center;
    margin: 12px auto;
  }
}

</style>
